import React from 'react'
import PropTypes from 'prop-types'
import compact from 'lodash/compact'

import Tag from '../tag/tag'
import TagSection from '../tag-section/tag-section'
import { availableSectionsPropType } from './props/available-sections-prop-type'
import { itemSourcesPropType } from './props/item-sources-prop-type'
import { sectionMappingPropType } from './props/section-mapping-prop-type'

const propTypes = {
    availableSections: availableSectionsPropType.isRequired,
    formatTagLabel: PropTypes.func,
    itemSources: itemSourcesPropType.isRequired,
    name: PropTypes.string.isRequired,
    onRemove: PropTypes.func.isRequired,
    sectionMapping: sectionMappingPropType.isRequired,
    tagSectionClassName: PropTypes.string
}

const getName = item => item.name

const defaultProps = {
    availableSections: [],
    formatTagLabel: getName
}

/**
 * This widget is part of <TagSectionEditor /> - see the docs there. It is not exposed to other outside use
 * Also see props.js for more info on the received propTypes
 */
function MappedTagSection(props) {
    const { availableSections, formatTagLabel, itemSources, name, onRemove, sectionMapping, tagSectionClassName } =
        props

    const section = availableSections.find(availableSection => sectionMapping.id === availableSection.id)

    if (!section) {
        return null
    }

    const tags = compact(
        sectionMapping.items.map((itemMapping, idx) => {
            const itemSource = itemSources.find(source => source.id === itemMapping.sourceId)

            if (!itemSource) {
                return null
            }

            const item = itemSource.items.find(item => item.id === itemMapping.itemId)

            if (!item) {
                return null
            }

            return (
                <Tag key={idx} id={itemMapping}>
                    {formatTagLabel(item)}
                </Tag>
            )
        })
    )

    if (tags.length === 0) {
        return null
    }

    return (
        <TagSection
            id={sectionMapping.id}
            onRemove={onRemove}
            className={tagSectionClassName}
            titleLeft={name}
            titleRight={section.name}
        >
            {tags}
        </TagSection>
    )
}

MappedTagSection.propTypes = propTypes
MappedTagSection.defaultProps = defaultProps

export default MappedTagSection
